import React, { MouseEvent } from "react";
import { IfComp } from "@dvrt/react-tools";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "@mui/material";
import { defineMessages, FormattedMessage, MessageDescriptor } from "react-intl";

export const translations = defineMessages({
    account_info: {
        id: "user_info.account_info",
        defaultMessage: "Account Info",
    },
    empty: {
        id: "user_info.empty",
        defaultMessage: "There are no active sessions for this user!",
    },
    client: {
        id: "user_info.client",
        defaultMessage: "$client.client",
    },
    ip: {
        id: "user_info.ip",
        defaultMessage: "IP",
    },
    time: {
        id: "user_info.time",
        defaultMessage: "Time",
    },
});

export const Item = ({
    href,
    onClick,
    icon,
    message,
}: {
    href: string;
    onClick?: () => void;
    icon?: IconDefinition;
    message: MessageDescriptor;
}) => {
    const clickHandler = onClick
        ? (event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              onClick();
          }
        : null;
    return (
        <MenuItem onClick={clickHandler} component="a" href={href}>
            <IfComp condition={icon !== undefined}>
                <FontAwesomeIcon icon={icon} style={{ paddingRight: "5px" }} />
            </IfComp>
            <FormattedMessage {...message} />
        </MenuItem>
    );
};
